import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { LockOutlined as Lock } from '@mui/icons-material';
import { useTranslate } from 'react-admin';

/** Marks the combined row that is generated from the front and back sides (the one exception in the side column). */
export const BothRowBadge: React.FC = () => {
  const t = useTranslate();
  return (
    <Tooltip title={t('fields-mapping.both.badge_tooltip')} enterTouchDelay={0}>
      <Chip size="small" color="info" icon={<Lock />} label={t('fields-mapping.both.badge_label')} />
    </Tooltip>
  );
};
